import $fn from "@/utils/fn";
export const SHOP_STATE_LIST = [
  {
    id: -4,
    title: "取回失败",
  },
  {
    id: -3,
    title: "上架失败",
  },
  {
    id: -2,
    title: "已失效",
  },
  {
    id: 1,
    title: "已上架",
  },
  {
    id: 2,
    title: "已下架",
  },
  {
    id: 3,
    title: "出售中",
  },
  {
    id: 4,
    title: "已出售",
  },
  /* {
    id: 5,
    title: "买家拒绝购买",
  }, */
  {
    id: 6,
    title: "上架中",
  },
  {
    id: 7,
    title: "取回中",
  },
];
export const SHOP_COLUMNS = [
  {
    title: "上架人账号",
    key: "username",
    align: "left",
  },
  {
    title: "商品编号",
    key: "id",
    align: "left",
  },
  {
    title: "商品类型",
    key: "type",
    align: "left",
  },
  {
    title: "商品状态",
    key: "status_text",
    align: "left",
  },
  {
    title: "价格",
    key: "price",
    align: "left",
  },
  {
    title: "角色名称",
    slot: "price",
    align: "left",
    render: (h, p) => {
      return h(
        "span",
        p.row.type == "货币"
          ? ""
          : p.row.type == "装备"
          ? p.row.title
          : p.row.role
      );
    },
  },
  {
    title: "所属游戏/区服",
    key: "game_name",
    slot: "game_name",
    align: "left",
  },
  {
    title: "是否被屏蔽",
    slot: "is_shield",
    align: "center",
    render: (h, p) => {
      return h("span", p.row.is_shield == 1 ? "是" : "否");
    },
  },
  {
    title: "回档时间",
    key: "server_retreated_time",
    align: "center",
    render: (h, params) => {
      const times = `${$fn.toDateSymbol(
        params.row.server_retreated_time
      )}-${$fn.toDateSymbol(params.row.server_retreated_create_time)}`;
      return h("span", !times ? "" : times);
    },
  },
  {
    title: "上架时间",
    key: "create_time",
    align: "left",
  },
];
